export const IMPORT_UPLOAD_MAX_BYTES = 32 * 1024 * 1024;

export const IMPORT_UPLOAD_ACCEPT = '.xlsx';

export const IMPORT_UPLOAD_DROPZONE_HINT = 'XLSX only — up to 32 MB';
